<template>
  <v-app :style="{ background: $vuetify.theme.themes[theme].background }">
    <v-content>
      <router-view v-if="loading === false">
        <template v-slot:header></template>
        <template v-slot:main></template>
        <template v-slot:nav></template>
        <template v-slot:footer></template>
      </router-view>
      <span v-else>
        <v-dialog v-model="loading" hide-overlay persistent width="300">
          <v-card color="primary" dark>
            <v-card-text class="text-center p-t-10">
              Please stand by
              <v-progress-linear
                      indeterminate
                      color="white"
                      class="mb-0"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
      </span>
    </v-content>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import storage from '../../utility/storage'

export default {
  name: 'Internal',
  beforeRouteUpdate (to, from, next) {
    next()
  },
  computed:{
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
    ...mapGetters('auth', ['user']),
  },
  data () {
    return {
      loading: true
    }
  },
  watch: {
    user (value) {
      if (value) {
        this.loading = false
      }
    }
  },
  mounted () {
    if (storage.getString('is_undermaintenance') == 'true') {
      this.$router.push({name: 'maintenance'})
    }
    this.loadUser()
    this.loadMember()
    this.loadProducts()
    this.loadSettings()
    this.loadNotifications()
  },
  methods: {
    ...mapActions('auth', { 'loadUser': 'loadCurrentUser' }),
    ...mapActions('member', {'loadMember': 'getMember', 'loadProducts': 'getProducts', 'loadSettings': 'getSettings', 'loadNotifications': 'getNotifications'}),
    logout () {
      this.$store.dispatch('auth/logout').then(() => {
        this.$router.push({ name: 'auth-login' })
      })
    }
  }
}
</script>
